import {
    graphql
} from 'react-relay'


const query = graphql`
    query getAllGovernorateQuery ($pagination: PaginationInput, $sorts: [OrderInput!], $where: JSON) {
        getAllGovernorate (pagination: $pagination, sorts: $sorts, where: $where) {
            count,
            items {
                id
                name
                countryId
                country{id, name}
                createdAt
                updatedAt
            }
      }
    }
  `

  export default query;